export const testimonials = [
  {
    id: 1,
    name: 'Rajesh Patil',
    location: 'Jaripatka, Nagpur',
    rating: 5,
    review: 'Excellent service! Imran bhai and his team fixed my bike issue quickly. Very honest pricing and quality work. Highly recommended!'
  },
  {
    id: 2,
    name: 'Amit Deshmukh',
    location: 'Sadar, Nagpur',
    rating: 5,
    review: 'Been coming here for 3 years now. Best garage in Nagpur for two-wheelers. Professional service and genuine parts always.'
  },
  {
    id: 3,
    name: 'Priya Sharma',
    location: 'Dharampeth, Nagpur',
    rating: 5,
    review: 'My scooty was making strange noises. They diagnosed and fixed it perfectly. Very reasonable rates and trustworthy mechanics.'
  },
  {
    id: 4,
    name: 'Sunil Kumar',
    location: 'Wardhaman Nagar, Nagpur',
    rating: 5,
    review: 'Helped me with insurance claim and complete servicing. SK Automobiles is a one-stop solution for all bike needs!'
  },
  {
    id: 5,
    name: 'Deepak Meshram',
    location: 'Manish Nagar, Nagpur',
    rating: 5,
    review: 'Got my bike exchanged here. Fair valuation and smooth process. Imran sir is very knowledgeable and helpful.'
  },
  {
    id: 6,
    name: 'Sneha Waghmare',
    location: 'Pratap Nagar, Nagpur',
    rating: 5,
    review: 'They handle BS-6 bikes expertly! My new Activa servicing was done perfectly. Will always come back here.'
  }
];
